module.exports = __webpack_public_path__ + "static/media/notification.f4b8e295.svg";